import React, { useState, useEffect } from "react";

// import logoMobile from "../static/img/logo-mobile.png";
import { useTranslation } from "react-i18next";
// import flagAW from "../static/flags/4x3/eu.svg";
// import flagIT from "../static/flags/4x3/it.svg";
// import flagGR from "../static/flags/4x3/gr.svg";

import AuthService from "../../../class/services/AuthService";
import UserServices from "../../../class/User_copy/UserService";
// import UserService from "../../../class/User/UserService";
import JackpotModal from "../modal/modal_jackpot";

// const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "ws.xyztown.info";
import { useWebSocket } from '../../../context/WebSocketContext';


const currencyFlags = {
    EUR: "/assets/flags/4x3/eu.svg",
    // COP: '/assets/flags/4x3/it.svg',
    // PEN: '/assets/flags/4x3/gr.svg',
    // CHF: '/assets/flags/4x3/gr.svg'
};

const HeaderLogin = ({
    forceMobile,
    setForceMobile,
    casinoSections,
    setIsUserCashBlocked,
    withdrawSection,
}) => {
    const [balance, setBalance] = useState(null);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();
    const [selectedCurrency, setSelectedCurrency] = useState({
        value: "EUR",
        text: "R$ 1.000,00",
        flag: "/assets/flags/4x3/eu.svg",
    });
    const [showSelectItems, setShowSelectItems] = useState(false);

    const [currencies, setCurrencies] = useState([]);
    const { connectWebSocket, isConnected, sendMessage, addListener, removeListener } = useWebSocket();

    const [showJackpotModal, setShowJackpotModal] = useState(false);
    const [userClass, setUserClass] = useState("bronze");
    const [jackpotAmount, setJackpotAmount] = useState(0);

    const fetchBalance = async () => {
        try {
            const userId = AuthService.getCustom("user_id");

            var currency = "EUR";

            if (AuthService.getCustom("currency")) {
                currency = AuthService.getCustom("currency");
            }

            const balanceData = await UserServices.getbalance(
                userId,
                currency,
                2,
            );

            if (balanceData.status != "ok") {
                AuthService.clearAll();
                window.location.reload();
            }

            setBalance(balanceData.params.balance);
        } catch (error) {
            console.error("Error fetching balance:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (AuthService.getCustom("currency")) {
            handleCurrencySelect(
                AuthService.getCustom("currency"),
                "",
                "/assets/flags/4x3/eu.svg",
            );
        }

        

        fetchBalance();
    }, []);

    const openJackpotModal = () => {
        setJackpotAmount(Math.floor(Math.random() * 1000) + 1); // Випадкова сума
        setShowJackpotModal(true);
    };

    const closeJackpotModal = () => {
        setShowJackpotModal(false);
    };

    const handleLogout = (event) => {
        event.preventDefault();
        setIsUserCashBlocked(false);
        AuthService.clearAll();
        window.location.href = "/";
    };

    useEffect(() => {

        if (!loading && !isConnected) {
            connectWebSocket();
        }
        if (!loading && isConnected) {
            // const socket = new WebSocket(`wss://${SOCKET_URL}`);
            // console.log('Connecting to WebSocket...', socket);
            // console.log("BALANCE", balance);


            // check if WebSocket is connected before sending messages
            // if (isConnected) { 
            const userId = AuthService.getCustom("user_id");
            const SKIN_ORDER = AuthService.getCustom("skin_order");
            // const api_key = AuthService.getCustom("api_key");

            const USER_ID = `${userId}_${SKIN_ORDER}`;
            const message = "LOGIN|" + USER_ID;


            sendMessage(message);

            addListener("BALANCE", (data) => {
                const [credits, bonus] = data;
                setBalance({
                    credits: credits,
                    bonus: !isNaN(Number(bonus)) ? bonus : "0.00",
                })
            });

            addListener("REFRESH_BALANCE", (data) => {
                fetchBalance();
            });

            return () => {
                removeListener("BALANCE", () => { });
                removeListener("REFRESH_BALANCE", () => { });
            }
            // }

            // socket.onopen = () => {
            //     // console.log("Send message to connect with ws");

            //     const SKIN_TOKEN = AuthService.getCustom("skin_token");
            //     const SKIN_ORDER = AuthService.getCustom("skin_order");
            //     const USER_ID = `${userId}_${SKIN_ORDER}`;
            //     const message = "LOGIN|" + USER_ID;
            //     socket.send(
            //         // JSON.stringify({
            //         //     USER_ID,
            //         //     SKIN_TOKEN,
            //         //     BALANCE: {
            //         //         ...balance,
            //         //         currency: selectedCurrency.value,
            //         //     },
            //         // }),
            //         message
            //     );
            // };

            // socket.onmessage = (event) => {
            //     try {
            //         // const message = JSON.parse(event.data);
            //         // console.log("Received WebSocket message:", message);
            //         // console.log("Not parsed message:", event.data);
            //         // console.log("Received WebSocket message:", message);
            //         // console.log("Selected currency:", selectedCurrency);
            //         const [action, credits, bonus] = event.data.split(";");

            //         if (action === "BALANCE") {
            //             setBalance({
            //                 credits: credits,
            //                 bonus: !isNaN(Number(bonus)) ? bonus : "0.00",
            //             });

            //             console.log("Updated balance from WebSocket:", {
            //                 credits: credits,
            //                 bonus: !isNaN(Number(bonus)) ? bonus : "0.00",
            //             });
            //         }

            //         // if (
            //         //     message.NEW_BALANCE &&
            //         //     message.CURRENCY === selectedCurrency.value
            //         // ) {
            //         //     const newBalance = message.NEW_BALANCE || 0;
            //         //     const bonus = message.BONUS || 0;
            //             // setBalance((prevBalance) => ({
            //             //     // ...prevBalance,
            //             //     // user_data: [
            //             //     //   {
            //             //     // ...prevBalance?.user_data[0],
            //             //     // balance: newBalance.balance,
            //             //     credits: newBalance,
            //             //     // balance_withdrawable: newBalance.balance_withdrawable,
            //             //     bonus: bonus,
            //             //     // available_balance: newBalance.available_balance,
            //             //     // },
            //             //     // ],
            //             // }));

            //         //     // console.log("==== UPDATE BALANCE ====");
            //         // }
            //     } catch (error) {
            //         console.error("Error parsing WebSocket message:", error);
            //     }
            // };

            // setWs(socket);

            // return () => {
            //     socket.close();
            // };
        }
    }, [loading, isConnected]);

    // useEffect(() => {
    //   const fetchCurrencies = async () => {
    //     try {
    //       const { cur_list } = await UserService.getCurList(AuthService.getCustom('user_id'));
    //       setCurrencies(cur_list);
    //     } catch (error) {
    //       console.error('Error fetching currencies:', error);
    //     }
    //   };

    //   fetchCurrencies();
    // }, []);

    // Обробка вибору валюти
    const handleCurrencySelect = (value, text, flag) => {
        const fetchBalance = async (currency) => {
            try {
                const userId = AuthService.getCustom("user_id");
                const balanceData = await UserServices.getbalance(
                    userId,
                    currency,
                );
                setBalance(balanceData);
            } catch (error) {
                console.error("Error fetching balance:", error);
            } finally {
                setLoading(false);
            }
        };

        AuthService.setCustom("currency", value);
        setSelectedCurrency({ value, text, flag });
        fetchBalance(value);
        setShowSelectItems(false);
    };

    // Закриваємо випадаючий список при кліку поза ним
    // useEffect(() => {
    //   const handleClickOutside = (event) => {
    //     if (!event.target.closest('.custom-select')) {
    //       setShowSelectItems(false);
    //     }
    //   };
    //   document.addEventListener('click', handleClickOutside);

    //   return () => {
    //     document.removeEventListener('click', handleClickOutside);
    //   };
    // }, []);

    return (
        <>
            <nav className="headerTopNav navbar navbar-expand-lg navbar-light bg-light fixed-top">
                <div className="container-fluid">
                    <a className="navbar-brand" href="#">
                        <img
                            src={`/assets/img/logo-mobile.png?ts=${new Date().getTime()}`}
                            alt="Nome-sito"
                        />
                    </a>
                    <div className="nav_account">
                        <div className="custom-select">
                            <div
                                className="select-selected"
                                data-value={selectedCurrency.value}
                                // onClick={() => setShowSelectItems(!showSelectItems)}
                            >
                                <img
                                    src={selectedCurrency.flag}
                                    alt={`Opzione ${selectedCurrency.value}`}
                                />{" "}
                                {loading ? (
                                    <span> {t("loading")}...</span> // Показуємо, поки баланс завантажується
                                ) : balance ? (
                                    `${selectedCurrency.value} ${(parseFloat(balance.credits) + parseFloat(balance.bonus)).toFixed(2)}`
                                ) : (
                                    selectedCurrency.text
                                )}
                            </div>
                            {showSelectItems && (
                                <div className="select-items d-block">
                                    {Array.isArray(currencies) &&
                                    currencies.length > 0 ? (
                                        currencies
                                            .filter(
                                                ({ currency }) =>
                                                    currency !==
                                                    selectedCurrency.value,
                                            )
                                            .map(
                                                ({
                                                    currency,
                                                    available_balance,
                                                }) => (
                                                    <div
                                                        key={currency}
                                                        onClick={() =>
                                                            handleCurrencySelect(
                                                                currency,
                                                                `${currency}`,
                                                                currencyFlags[
                                                                    currency
                                                                ] ||
                                                                    "/assets/flags/4x3/eu.svg",
                                                            )
                                                        }
                                                        data-value={currency}
                                                    >
                                                        <img
                                                            src={
                                                                currencyFlags[
                                                                    currency
                                                                ] ||
                                                                "/assets/flags/4x3/eu.svg"
                                                            }
                                                            alt={`Opzione ${currency}`}
                                                        />{" "}
                                                        {currency}{" "}
                                                        {available_balance}
                                                    </div>
                                                )
                                            )
                                    ) : (
                                        <p>No more currencies available</p>
                                    )}
                                </div>
                            )}
                        </div>
                        <ul className="nav" style={{ flexWrap: "nowrap" }}>
                            {/* <li className="nav-item">
              <a className="assitence sb-chat-btn" href="javascript:SBChat.initChat();SBChat.open()">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512 512"
                  style={{ enableBackground: 'new 0 0 512 512' }}
                  xmlSpace="preserve"
                >
                  <path d="M398.2,0H113.8C50.9,0,0,50.9,0,113.8v368.7c-0.1,2.3,0.1,4.5,0.5,6.7c0,0.2,0.1,0.4,0.1,0.7c0,0.2,0.1,0.4,0.1,0.5c0.1,0.4,0.2,0.8,0.3,1.2c0,0,0,0,0,0C4.6,503.4,15.5,512,28.4,512c8.6,0,16.4-3.9,21.6-9.9l104-103.9h244.2c62.8,0,113.8-50.9,113.8-113.8V113.8C512,50.9,461.1,0,398.2,0z M455.1,284.5c-0.1,31.4-25.5,56.8-56.9,56.9h-256c-7.5,0-14.8,3-20.1,8.3l-65.2,65.1v-301C57,82.4,82.4,57,113.8,56.9h284.4c31.4,0.1,56.8,25.5,56.9,56.9V284.5z"></path>
                  <path d="M369.8,113.9H142.2c-15.7,0-28.4,12.7-28.4,28.4c0,15.6,12.7,28.4,28.4,28.4h227.6c15.7,0,28.4-12.7,28.4-28.4C398.2,126.6,385.5,113.9,369.8,113.9z"></path>
                  <path d="M312.9,227.6H142.2c-15.7,0-28.4,12.7-28.4,28.4s12.7,28.4,28.4,28.4h170.7c15.7,0,28.4-12.7,28.4-28.4S328.6,227.6,312.9,227.6z"></path>
                </svg>
              </a>

              
            </li> */}
                            <li className="nav-item logged dropdown">
                                <a
                                    className="login"
                                    id="navbarDropdown"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <svg
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 512 512"
                                        style={{
                                            enableBackground: "new 0 0 512 512",
                                        }}
                                        xmlSpace="preserve"
                                    >
                                        <path d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40c59.551,0,108,48.448,108,108S315.551,256,256,256z"></path>
                                    </svg>
                                </a>
                                <div
                                    className="dropdown-menu account-dropdown dropdown-menu-end"
                                    aria-labelledby="navbarDropdown"
                                >
                                    <div className="box-account">
                                        <div className="header-account">
                                            <h3>
                                                <small>{t("welcome")}</small>
                                                <br />
                                                <div id="username">
                                                    {AuthService.getCustom(
                                                        "username",
                                                    )}
                                                </div>
                                            </h3>
                                        </div>
                                        <div className="balance">
                                            {balance && (
                                                <>
                                                    {/* <p>
                        {t('Drawable_balance')}<strong > {selectedCurrency.value} {balance.user_data[0].balance_withdrawable}</strong>
                        </p> */}
                                                    <p>
                                                        {t("Balance")}
                                                        <strong>
                                                            {" "}
                                                            {
                                                                selectedCurrency.value
                                                            }{" "}
                                                            {parseFloat(
                                                                balance.credits
                                                            )}
                                                        </strong>
                                                    </p>
                                                    <p>
                                                        {t("Bonus")}
                                                        <strong>
                                                            {
                                                                selectedCurrency.value
                                                            }{" "}
                                                            {parseFloat(
                                                                balance.bonus
                                                            )}
                                                        </strong>
                                                    </p>
                                                    <p>
                                                        {t("Total_balance")}
                                                        <strong>
                                                            {" "}
                                                            {
                                                                selectedCurrency.value
                                                            }{" "}
                                                            {(
                                                                parseFloat(
                                                                    balance.credits
                                                                ) +
                                                                parseFloat(
                                                                    balance.bonus
                                                                )
                                                            ).toFixed(2)}
                                                        </strong>
                                                    </p>
                                                </>
                                            )}
                                        </div>
                                        <div className="account-btn-footer">
                                            <a href="/profile/account_setting">
                                                {t("Profile")}
                                            </a>
                                            {!withdrawSection && (
                                                <a href="/profile/deposit_withdraw">
                                                    {t("Deposit")}
                                                </a>
                                            )}
                                        </div>
                                        <a
                                            className="log-out"
                                            href="/logout"
                                            onClick={handleLogout}
                                        >
                                            <svg
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 24.303 24.303"
                                                style={{
                                                    enableBackground:
                                                        "new 0 0 24.303 24.303",
                                                }}
                                                xmlSpace="preserve"
                                            >
                                                <g>
                                                    <path d="M10.269,11.298V1.883C10.269,0.844,11.113,0,12.152,0s1.883,0.844,1.883,1.883v9.415c0,1.039-0.844,1.883-1.883,1.883S10.269,12.337,10.269,11.298z M19.616,2.761c-0.61-0.483-1.5-0.377-1.983,0.234c-0.483,0.612-0.378,1.5,0.234,1.984c2.24,1.767,3.524,4.413,3.524,7.261c0,5.094-4.145,9.239-9.238,9.239c-5.094,0-9.239-4.145-9.239-9.239c0-2.847,1.283-5.492,3.521-7.258c0.612-0.483,0.717-1.371,0.234-1.984c-0.483-0.612-1.37-0.716-1.984-0.234C1.764,5.069,0.089,8.523,0.089,12.24c0,6.652,5.412,12.063,12.063,12.063s12.063-5.412,12.063-12.063C24.215,8.521,22.538,5.067,19.616,2.761z"></path>
                                                </g>
                                            </svg>
                                            {t("Exit")}
                                        </a>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            {/* <JackpotModal
                show={showJackpotModal}
                handleClose={closeJackpotModal}
                userClass={userClass}
                jackpotAmount={jackpotAmount}
            /> */}
        </>
    );
};

export default HeaderLogin;
